import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { setAuthToken } from "../lib/api";

/**
 * Landing page that activates an admin-issued impersonation token (opens in a NEW tab
 * so the admin's own session in the original tab is preserved untouched).
 * Closing the tab is enough to end the session.
 */
export default function ImpersonateLanding() {
  const [params] = useSearchParams();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    const token = params.get("t");
    const name = params.get("name") || "";
    if (!token) {
      window.location.replace("/login");
      return;
    }
    try {
      // Flag this tab as an impersonation session (banner reads this)
      sessionStorage.setItem("impersonation_active", "1");
      sessionStorage.setItem("impersonation_target_name", name);
      // Set the impersonation token (writes to sessionStorage + memory in this tab only)
      setAuthToken(token);
      // Decode role to choose redirect target
      let role = "passenger";
      try {
        const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
        role = payload.role || "passenger";
      } catch { /* noop */ }
      const dest = role === "driver" ? "/driver" : role === "passenger" ? "/passenger" : "/";
      window.location.replace(dest);
    } catch {
      window.location.replace("/login");
    }
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A2540] text-white" data-testid="impersonate-landing">
      <div className="text-center px-6">
        <ShieldCheck className="w-12 h-12 text-[#FACC15] mx-auto mb-3" />
        <h1 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit' }}>Ouverture de la session de support…</h1>
        <p className="text-sm text-white/70 mb-6">Activation d&apos;une session temporaire en cours</p>
        <Loader2 className="w-6 h-6 animate-spin mx-auto" />
      </div>
    </div>
  );
}
